
'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <section ref={ref} className="py-12 sm:py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-6 sm:mb-8 md:mb-10"
        >
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-black mb-3 sm:mb-4 md:mb-6 leading-tight">
            Tired of Cheap Lighters That Die When You Need Them Most?
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-center space-y-4 sm:space-y-5 md:space-y-6"
        >
          <p className="text-black/80 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
            You know the feeling. You&apos;re out with friends, need a light, and click... nothing. Dead. Again.
          </p>

          <p className="text-black/80 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
            Most people waste <strong className="text-black font-bold">$200+ per year</strong> on disposable lighters that break, run out of fuel, or stop working in the cold. Meanwhile, your cigarettes get crushed in your pocket, and you look unprepared when it matters.
          </p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-black font-bold text-base sm:text-lg md:text-xl lg:text-2xl pt-2 sm:pt-3 md:pt-4"
          >
            There&apos;s a better way.
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}
